import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProductionCompany = createAsyncThunk(
  "production/fetchCompany",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/production-companies`, {
        headers: {
          'Accept-Language': lang || 'en'
        }
      });
      return response.data.data; 
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch production companies";
      return rejectWithValue({ message });
    }
  }
);